import React, { Component } from 'react';
import { Container, Divider, Checkbox, Grid, Button, Card } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import utils from 'utils/utils.js';
import actions from 'actions';
import { api } from 'api';

class Welcome extends Component {
  state = { agreeTerms: false }
  showConditions = () => {
    const { trial } = this.props;
    utils.alert('Trial terms', trial.conditions);
  }

  continue = () => {
    const { agreeTerms } = this.state;
    const { participant } = this.props;
    api.trials.createConditionsAgreement(this.props.trial._id, agreeTerms, ({ trialConditionAgreements }) => {
      this.props.onReceiveAgreements(participant._id, trialConditionAgreements);
    }, err => toast.error(err.message));
  }

  render() {
    const { t, trial, team } = this.props;
    const { agreeTerms } = this.state;
    return (
      <Container style={{marginTop: 40}}>
        <Grid stackable centered>
          <Grid.Column computer={6} textAlign='center'>
            <Card>
              <Card.Content textAlign='left'>
                <Card.Header>{trial.name}</Card.Header>
                <Card.Meta>{t('trial.presentedBy', { teamName: team && team.name })}</Card.Meta>
              </Card.Content>
            </Card>
          </Grid.Column>
          <Grid.Column computer={8}>
            <h1>{t('trial.welcome')}</h1>
            <p className='break-lines'>{trial.description}</p>

            <Divider section hidden/>

            <h3>Agree to the trial terms</h3>
            <p>To continue, please indicate your agreement to the Conditions of the trial.</p>
            <Button onClick={this.showConditions} content='View conditions' size='small' style={{marginRight: 10, marginBottom: 15}}/>
            <Checkbox toggle checked={agreeTerms} onChange={(e, c) => this.setState({ agreeTerms: c.checked })} label='I have read and agree to the Conditions' />

            <Divider hidden />

            {agreeTerms &&
              <Button color='teal' fluid content='Continue' onClick={this.continue}/>
            }
          </Grid.Column>
        </Grid>
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  const { currentParticipantId, isLoadingMe } = state.participants;
  const participant = state.participants.participants.filter(p => p._id === currentParticipantId)[0];
  const trial = state.trials.trials.filter(t => t._id === (participant && participant.trial))[0];
  const team = state.teams.teams.filter(t => t._id === (participant && participant.team))[0];
  return { isLoadingMe, participant, trial, team };
};
const mapDispatchToProps = dispatch => ({
  onReceiveAgreements: (id, agreements) => dispatch(actions.participants.receiveAgreements(id, agreements)),
});

const WelcomeContainer = withTranslation()(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(Welcome)));

export default WelcomeContainer;
